export const courseLevelAnalyticsRootText = {
  analytics: 'Analytics',
  learners: 'Learners',
  selectCourse: 'Select course...',
  passed: 'Passed',
  failed: 'Failed',
  avgTime: 'Average training time',
  avgScore: 'Average score',
  completed: 'Completed',
  inProgress: 'In progress',
  participatory: 'Participatory',
  export: 'Export',
};
